import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import NewServiceSidebar from "../../components/Services/SingleServiceComponents/NewServiceSideBar";
import DropdownMenuServices from "../../components/Services/DropdownMenuServices";
import {
  FileDown,
  FileSpreadsheet,
  FileText,
  Link2,
  ListChecks,
  Settings,
  X,
} from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BasicDetails from "../../components/Services/SingleServiceComponents/BasicDetails";
import NewServiceTabMobile from "../../components/Services/SingleServiceComponents/NewServiceTabMobile";
import TeamMembersSelect from "../../components/Services/SingleServiceComponents/TeamMemberSelect";
import ResourcesRequired from "../../components/Services/SingleServiceComponents/ResourceRequire";
import ServiceAddOns from "../../components/Services/SingleServiceComponents/ServiceAddOns";
import OnlineBooking from "../../components/Services/SingleServiceComponents/OnlineBooking";
import Commission from "../../components/Services/SingleServiceComponents/Commission";
import NewServiceSettings from "../../components/Services/SingleServiceComponents/NewServiceSetting";
import { ArrowLeft } from "lucide-react"; // instead of X
import menuApi from "../../api/menu/menu.api";
import Loading from "../../Util/Loading";

const members = [
  { id: 1, name: "Mira Dinh", role: "Nail Technician", initials: "MD" },
  { id: 2, name: "Ruby Dinh", role: "Spa Technician", initials: "RD" },
  { id: 3, name: "Yen Nguyen", role: "Spa Technician", initials: "YN" },
  { id: 4, name: "Yuna", role: "Spa Technician", initials: "Y" },
];

const SingleService = () => {
  const { search } = useLocation();

  const params = new URLSearchParams(search);
  const categoryId = params.get("categoryId");

  const { id } = useParams(); // ✅ NEW
  const isEdit = !!id;

  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(isEdit);

  const [selected, setSelected] = useState("basic");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isEdit) {
      // ✅ CREATE MODE
      setInitialData({
        serviceName: "",
        description: "",
        price: "",
        duration: "",
        priceType: "",
        category: categoryId || null,
      });
      return;
    }

    // ✅ EDIT MODE
    const load = async () => {
      try {
        const res = await menuApi.getMenuItemDetail(id);

        const service = res?.foodItem || res;

        setInitialData({
          serviceName: service?.title || "",

          // ✅ FIX: use desc (not description)
          description: service?.desc || "",

          price: service?.price || "",
          duration: service?.desc || "", // (you are using desc as duration — OK if intentional)

          priceType: service?.priceType || "",

          // ✅ IMPORTANT: keep full object for dropdown
          category: service?.category || null,

          // ✅ ADD THESE (you were missing them)
          subdesc: service?.subdesc || [],
          isActive: service?.isActive ?? true,
          isNewItem: service?.isNewItem ?? false,
          isStaffChoice: service?.isStaffChoice ?? false,

          // ✅ image for edit preview
          image: service?.image || "",
        });
      } catch (err) {
        console.error("Error loading service:", err);
        navigate("/services"); // fallback
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, isEdit, categoryId, navigate]);

  if (loading || !initialData) return <Loading />;

  return (
    <Layout>
      <div className="p-4 md:p-6 w-full container mx-auto bg-dry min-h-screen">
        <div className="bg-dry text-text rounded-lg min-h-screen mt-6">
          {/* Header */}
          <div className="flex items-start lg:items-center justify-between mb-6">
            <div className="flex flex-col items-start justify-center">
              <h2 className="text-xl font-semibold text-yellowstar animate-neonFlicker uppercase tracking-wide">
                {isEdit ? "Edit Service" : "New Service"}
              </h2>
              <p className="text-sm">
                {isEdit
                  ? "Update your service."
                  : "Create and configure a new service."}{" "}
              </p>
            </div>

            {/* Desktop Buttons */}
            <div className="hidden md:flex gap-2">
              <div className="flex justify-end  p-4">
                <button
                  className="px-4 py-2 rounded-md border text-navy border-border mr-2 hover:bg-yellowstar hover:text-navy"
                  onClick={() => navigate(-1)}
                >
                  Close
                </button>
              </div>
            </div>

            <button
              onClick={() => navigate(-1)}
              className="md:hidden absolute top-[100px] right-4 text-redlight bg-drylight rounded-xl p-1 hover:text-white"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Search + Filter Row */}
          {/* <div className="flex gap-3 mb-6"> */}
          {/* <input
              type="text"
              placeholder="Search service name"
              className="flex-1 border border-border rounded-md px-3 py-2 text-sm bg-dry placeholder-text-gray"
            /> */}
          {/* <div className="flex gap-2">
              <button className="px-3 py-2 border border-border rounded-md text-sm">
                Filters
              </button>
              <button className="hidden lg:block px-3 py-2 border border-border rounded-md text-sm">
                Manage order
              </button>
            </div> */}
          {/* </div> */}

          {/* Mobile tabs */}
          <NewServiceTabMobile selected={selected} onSelect={setSelected} />

          {/* Main Two-Column Layout */}
          <div className="flex rounded-lg min-h-[70vh] gap-3">
            {/* Sidebar */}
            <NewServiceSidebar selected={selected} onSelect={setSelected} />

            {/* Main content */}
            <main className="flex-1 pt-3 lg:pt-3 lg:pl-3 overflow-y-auto">
              {selected === "basic" && (
                <BasicDetails
                  initialData={initialData}
                  isEdit={isEdit}
                  serviceId={id}
                  categoryId={categoryId}
                />
              )}
              {selected === "team" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  Team Members
                </h1>
                // <TeamMembersSelect members={members} />
              )}
              {selected === "resources" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  ResourcesRequired{" "}
                </h1>

                //  <ResourcesRequired />
              )}
              {selected === "addons" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  Service Add Ons{" "}
                </h1>
                // <ServiceAddOns />
              )}
              {selected === "online" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  Online Booking{" "}
                </h1>
                // <OnlineBooking />
              )}
              {selected === "forms" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  Forms section
                </h1>
              )}
              {selected === "commissions" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  Commission
                  {/* <Commission /> */}
                </h1>
              )}
              {selected === "settings" && (
                <h1 className="text-xl font-semibold text-navy uppercase tracking-wide">
                  General settings
                  {/* <NewServiceSettings /> */}
                </h1>
              )}
            </main>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SingleService;
